import React from "react";
import { Link } from "react-router-dom";
import "./Enduring_Power_of_Attorney.css";

const EnduringPowerOfAttorney = () => {
  const topics = [
    {
      number: "01",
      title: "עניינים אישיים",
      text: "קביעת הנחיות בנוגע לאורח החיים, למקום המגורים, לטיפול האישי ולעניינים החשובים לאדם בחיי היום-יום."
    },
    {
      number: "02",
      title: "עניינים רפואיים",
      text: "הסדרת סמכויות והנחיות בנוגע לטיפול הרפואי, בהתאם לרצונות הממנה ולהוראות הדין."
    },
    {
      number: "03",
      title: "עניינים רכושיים",
      text: "קביעת מיופה כוח שיוכל לטפל בענייני רכוש, כספים ונכסים, בהתאם לסמכויות ולהנחיות שנקבעו במסמך."
    }
  ];

  const steps = [
    {
      number: "01",
      title: "היכרות והבנת הרצונות",
      text: "פגישה אישית להבנת רצונותיכם, הנסיבות המשפחתיות והנושאים שחשוב לכם להסדיר."
    },
    {
      number: "02",
      title: "בחירת מיופה הכוח",
      text: "בחינת זהותם של האנשים שבהם אתם נותנים אמון, הגדרת תחומי האחריות וקביעת הנחיות מקדימות."
    },
    {
      number: "03",
      title: "עריכת המסמך וחתימה",
      text: "ניסוח ייפוי הכוח המתמשך בהתאם להוראות הדין, הסבר על משמעותו והשלמת החתימות הנדרשות."
    },
    {
      number: "04",
      title: "הפקדה אצל האפוטרופוס הכללי",
      text: "הגשת המסמך להפקדה במערכת האפוטרופוס הכללי ומעקב אחר קבלת אישור ההפקדה."
    }
  ];

  return (
    <main
      className="enduring-page Enduring_Power_of_Attorney-page"
      dir="rtl"
    >

      {/* HERO */}

      <section className="Enduring_Power_of_Attorney-hero">
        <div className="Enduring_Power_of_Attorney-overlay">
          <h1>ייפוי כוח מתמשך</h1>
        </div>
      </section>

      {/* INTRO */}

      <section className="enduring-intro">
        <div className="enduring-container enduring-intro-grid">

          <div className="enduring-intro-content">
            <span className="enduring-section-label">
              לתכנן מראש. לבחור בעצמכם.
            </span>

            <h2>
              מהו ייפוי כוח מתמשך ולמה הוא חשוב?
            </h2>

            <p>
              ייפוי כוח מתמשך מאפשר לאדם בגיר, בעודו מסוגל להבין
              ולקבל החלטות, לבחור מראש אדם אחד או יותר שעליהם הוא
              סומך, אשר יוכלו לפעול בשמו בעתיד בהתאם להנחיותיו
              ולסמכויות שהעניק להם.
            </p>

            <p>
              במקום להשאיר את ההחלטות לעתיד לא ידוע, ניתן להביע
              מראש את הרצונות האישיים, לבחור מי יטפל בעניינים
              החשובים לכם ולהגדיר כיצד תרצו שיפעלו עבורכם.
            </p>

            <p>
              עריכת המסמך היא החלטה אישית ומשמעותית, ולכן חשוב
              להקדיש מחשבה לבחירת מיופה הכוח ולניסוח ההנחיות.
            </p>
          </div>

          <div className="enduring-quote-card">
            <div className="enduring-quote-mark">“</div>

            <p>
              הזכות לבחור מי יפעל בשמכם, כיצד יפעל ובאילו תנאים
              היא חלק חשוב מתכנון העתיד שלכם.
            </p>

            <span>משרד עורכי הדין רז יוסף</span>
          </div>

        </div>
      </section>

      {/* TOPICS */}

      <section className="enduring-topics">
        <div className="enduring-container">

          <div className="enduring-section-heading">
            <span className="enduring-section-label">
              מה ניתן להסדיר במסמך?
            </span>

            <h2>שלושה תחומים מרכזיים</h2>

            <p>
              ניתן לקבוע ייפוי כוח מתמשך לכלל העניינים או לחלק מהם,
              בהתאם לרצונות הממנה ולהוראות הדין.
            </p>
          </div>

          <div className="enduring-topics-grid">
            {topics.map((topic) => (
              <article className="enduring-topic-card" key={topic.number}>
                <span className="enduring-number">
                  {topic.number}
                </span>

                <h3>{topic.title}</h3>
                <p>{topic.text}</p>
              </article>
            ))}
          </div>

        </div>
      </section>

      {/* PROCESS */}

      <section className="enduring-process">
        <div className="enduring-container">

          <div className="enduring-section-heading">
            <span className="enduring-section-label">
              מה כולל התהליך?
            </span>

            <h2>עריכת ייפוי כוח מתמשך – שלב אחר שלב</h2>

            <p>
              תהליך מסודר המאפשר לכם לקבל החלטות מושכלות ולנסח
              מסמך המתאים לרצונותיכם.
            </p>
          </div>

          <div className="enduring-steps">
            {steps.map((step) => (
              <article className="enduring-step" key={step.number}>
                <div className="enduring-step-number">
                  {step.number}
                </div>

                <div className="enduring-step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </article>
            ))}
          </div>

        </div>
      </section>

      {/* CERTIFICATION */}

      <section className="enduring-certification">
        <div className="enduring-container enduring-certification-grid">

          <div className="enduring-certification-content">
            <span className="enduring-section-label">
              הכשרה מקצועית
            </span>

            <h2>
              הסמכה לעריכת ייפוי כוח מתמשך
            </h2>

            <p>
              עורך הדין רז יוסף עבר הכשרה מקצועית לעריכת ייפוי כוח
              מתמשך, בהתאם לדרישות האפוטרופוס הכללי.
            </p>

            <p>
              ההכשרה מאפשרת לעורך הדין לערוך ייפוי כוח מתמשך
              בהתאם להוראות הדין, להסביר לממנה את משמעות המסמך
              וללוות את תהליך עריכתו והפקדתו.
            </p>

            <div className="enduring-certification-highlight">
              ליווי משפטי אישי על ידי עורך דין שהוכשר לעריכת
              ייפוי כוח מתמשך.
            </div>
          </div>

          <div className="enduring-certificate-frame">
            <div className="enduring-certificate-heading">
              <span>תעודת הסמכה</span>
              <span className="enduring-certificate-icon">✦</span>
            </div>

            <div className="enduring-certificate-image">
              <img
                src="/555.jpeg"
                alt="תעודת ההסמכה של עורך הדין רז יוסף לעריכת ייפוי כוח מתמשך"
                loading="lazy"
              />
            </div>

            <p>
              תעודת ההסמכה של עורך הדין רז יוסף
            </p>
          </div>

        </div>
      </section>

      {/* IMPORTANT INFORMATION */}

      <section className="enduring-important">
        <div className="enduring-container">

          <div className="enduring-important-content">
            <h2>חשוב לדעת</h2>

            <p>
              ייפוי כוח מתמשך אינו נכנס לתוקף באופן אוטומטי עם
              חתימתו. הוא מופקד אצל האפוטרופוס הכללי, וניתן
              לפעול מכוחו רק לאחר שהתקיימו התנאים לכניסתו לתוקף
              בהתאם להוראות המסמך והדין.
            </p>

            <p>
              ניתן לקבוע מראש תנאים לכניסתו לתוקף, לבחור אנשים
              מיודעים שיקבלו מידע, ולהגדיר הנחיות למיופה הכוח.
              קיימות גם פעולות מסוימות שמחייבות הסמכה מפורשת
              במסמך או אישור בית משפט.
            </p>

            <a
              href="https://www.gov.il/he/service/edit_and_deposit_continuous_power_of_attorney"
              target="_blank"
              rel="noopener noreferrer"
              className="enduring-official-link"
            >
              מידע רשמי באתר משרד המשפטים
              <span>←</span>
            </a>
          </div>

        </div>
      </section>

   

    </main>
  );
};

export default EnduringPowerOfAttorney;
